import { render, staticRenderFns } from "./help-suggestion-chips.vue?vue&type=template&id=35062dea&scoped=true"
import script from "./help-suggestion-chips.vue?vue&type=script&lang=js"
export * from "./help-suggestion-chips.vue?vue&type=script&lang=js"
import style0 from "./help-suggestion-chips.vue?vue&type=style&index=0&id=35062dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35062dea",
  null
  
)

export default component.exports